var exports = {
  "Q": "x127c5a35--05fa3b--text",
};

module.exports = exports;
